export default "__VITE_ASSET__a5cb4d9b__"